module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "default"
    },
    slot: "default"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        'min': 3
      }),
      expression: "{'required': true, 'min': 3}"
    }],
    attrs: {
      "disabled": _vm.progress,
      "label": "Название",
      "error": _vm.errors.first('name'),
      "name": "name",
      "id": "name",
      "data-vv-name": "name",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.group.name),
      callback: function($$v) {
        _vm.$set(_vm.group, "name", $$v)
      },
      expression: "group.name"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true,
        'min': 3
      }),
      expression: "{'required': true, 'min': 3}"
    }],
    attrs: {
      "disabled": _vm.progress,
      "label": "Символьный код",
      "error": _vm.errors.first('code'),
      "name": "code",
      "id": "code",
      "data-vv-name": "code",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.group.code),
      callback: function($$v) {
        _vm.$set(_vm.group, "code", $$v)
      },
      expression: "group.code"
    }
  }), _vm._v(" "), _c('z-text-area', {
    attrs: {
      "disabled": _vm.progress,
      "label": "Описание",
      "error": _vm.errors.first('description'),
      "name": "description",
      "id": "description",
      "data-vv-name": "description",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.group.description),
      callback: function($$v) {
        _vm.$set(_vm.group, "description", $$v)
      },
      expression: "group.description"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "disabled": _vm.progress,
      "label": "Сортировка",
      "error": _vm.errors.first('sort'),
      "name": "sort",
      "id": "sort",
      "data-vv-name": "sort",
      "data-vv-as": ' ',
      "type": "number"
    },
    model: {
      value: (_vm.group.sort),
      callback: function($$v) {
        _vm.$set(_vm.group, "sort", $$v)
      },
      expression: "group.sort"
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d7b36f8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/Group.vue
// module id = 1097
// module chunks = 0